import { Base } from './base';
import { IUser } from './user';

export enum SubscriberPlanEnum {
	NONE = 'none',
	PREMIUM = 'premium',
	THERAPIST_A = 'therapistA',
	THERAPIST_B = 'therapistB',
}

export interface ISubscription extends Base {
	subscriptionId: string;
	customerId: string;
	customerEmail: string;
	subscriptionStartDate: Date;
	subscriptionEndDate: Date;
	activePlan: SubscriberPlanEnum;
	isPlanCancelled: boolean;
	isHardcoded?: boolean;
	user: IUser;
}
